/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modal_Submit_BusyInputs */

const en_modal_submit_busy = /** @type {(inputs: Modal_Submit_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting…`)
};

const ja_modal_submit_busy = /** @type {(inputs: Modal_Submit_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信中…`)
};

const fr_modal_submit_busy = /** @type {(inputs: Modal_Submit_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi en cours…`)
};

const de_modal_submit_busy = /** @type {(inputs: Modal_Submit_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet…`)
};

/**
* | output |
* | --- |
* | "Submitting…" |
*
* @param {Modal_Submit_BusyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const modal_submit_busy = /** @type {((inputs?: Modal_Submit_BusyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modal_Submit_BusyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_modal_submit_busy(inputs)
	if (locale === "ja") return ja_modal_submit_busy(inputs)
	if (locale === "fr") return fr_modal_submit_busy(inputs)
	return de_modal_submit_busy(inputs)
});